import {createSelector} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AsyncExportTypesEnum} from '../../../../models/api/analyticsExportModel';
import {getAnalyticsPanel} from '../analyticsPanelSelectors';

const getAnalyticsExports = createSelector([getAnalyticsPanel], ({exports}) => exports);

const getAnalyticsColumnNames = createSelector([getAnalyticsExports], ({columnNames}) => columnNames);

export const getAnalyticsCsatColumnNames = createSelector(
  [getAnalyticsColumnNames],
  (columnNames) => columnNames.csat,
);

export const getAnalyticsActivitiesColumnNames = createSelector(
  [getAnalyticsColumnNames],
  (columnNames) => columnNames.activities,
);

export const getAnalyticsMessagesColumnNames = createSelector(
  [getAnalyticsColumnNames],
  (columnNames) => columnNames.messages,
);

export const getAnalyticsEventTypes = createSelector([getAnalyticsExports], ({eventTypes}) => eventTypes);

const getAnalyticsExportsList = createSelector([getAnalyticsExports], ({exports}) => exports);

const getAnalyticsActivitiesExportsList = createSelector([getAnalyticsExportsList], (exports) =>
  exports.filter((ex) => ex.exportType === AsyncExportTypesEnum.ACTIVITIES),
);

const getAnalyticsMessagesExportsList = createSelector([getAnalyticsExportsList], (exports) =>
  exports.filter((ex) => ex.exportType === AsyncExportTypesEnum.MESSAGES),
);

export const getAnalyticsActivitiesOrMessagesExportsList = createSelector(
  [getAnalyticsActivitiesExportsList, getAnalyticsMessagesExportsList],
  (activitiesExports, messagesExports) => [...activitiesExports, ...messagesExports],
);

export const getAnalyticsCsatExportsList = createSelector([getAnalyticsExportsList], (exports) =>
  exports.filter((ex) => ex.exportType === AsyncExportTypesEnum.CSAT),
);

export const getIsCsatColumnsLoaded = createSelector(
  [getAnalyticsColumnNames],
  (columnNames) => columnNames.csat.length > 0,
);

const getIsActivitiesAndMessagesColumnsLoaded = createSelector(
  [getAnalyticsColumnNames],
  (columnNames) => columnNames.activities.length > 0 && columnNames.messages.length > 0,
);

const getIsEventTypesLoaded = createSelector([getAnalyticsEventTypes], (eventTypes) => eventTypes.length > 0);

export const getIsActivitiesAndMessagesColumnsAndEventTypesLoaded = createSelector(
  [getIsActivitiesAndMessagesColumnsLoaded, getIsEventTypesLoaded],
  (columnsLoaded, eventsLoaded) => columnsLoaded && eventsLoaded,
);
